import store from '@frontend/store';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import {
  DISPLAY_BUILDER_LAYER_META_KEY,
  getAdditionalBackgroundIndex,
} from '@frontend/components/display-builder/display-layer-metadata';

const DISPLAY_BUILDER_BACKGROUND_IMAGE_FIELDS = [
  'add_bk_img_angle',
  'add_bk_img_duplicate_data',
  'add_bk_img_flipX',
  'add_bk_img_flipY',
  'add_bk_img_height',
  'add_bk_img_is_mirror',
  'add_bk_img_masks',
  'add_bk_img_mirror_coords',
  'add_bk_img_mirror_delete_source',
  'add_bk_img_mirror_distance',
  'add_bk_img_mirror_fade',
  'add_bk_img_mirror_position',
  'add_bk_img_mirror_skew',
  'add_bk_img_offset_x',
  'add_bk_img_offset_y',
  'add_bk_img_opacity',
  'add_bk_img_order',
  'add_bk_img_scale',
  'add_bk_img_scale_y',
  'add_bk_img_shadow',
  'add_bk_img_width',
  'add_bk_img_object_fit',
  'add_bk_img_object_fill',
  DISPLAY_BUILDER_LAYER_META_KEY,
  'additional_background_images',
  'add_bk_img_is_another_instance',
  'add_bk_img_is_shifted',
  'add_bk_img_visible',
];

const getShowPageScope = () => ShowPageScopeCollector.get([
  'updateLayoutChanges',
  'canvas_data',
]);

export function deleteDisplayBuilderBackgroundLayer(fabricItemInstance) {
  if (!window.isDisplayBuilder || !fabricItemInstance?.canvas) {
    return false;
  }

  const { canvas_data, updateLayoutChanges } = getShowPageScope();
  const instanceId = fabricItemInstance.canvas.instance_id;
  const instanceData = canvas_data?.[instanceId];
  const currentData = instanceData?._data;
  const index = getAdditionalBackgroundIndex(fabricItemInstance);

  if (!currentData || index === null) {
    return false;
  }

  DISPLAY_BUILDER_BACKGROUND_IMAGE_FIELDS.forEach((key) => {
    if (!Array.isArray(currentData[key])) {
      return;
    }

    currentData[key].splice(index, 1);
    updateLayoutChanges?.(instanceId, key, currentData[key]);
  });

  if (Array.isArray(instanceData.additionalBkImgCoords)) {
    instanceData.additionalBkImgCoords.splice(index, 1);
  }

  const canvas = fabricItemInstance.canvas;
  const deletedElementId = fabricItemInstance.element_id;

  store.commit('layout/DELETE_LAYER', deletedElementId);

  canvas.getObjects().forEach((object) => {
    if (object === fabricItemInstance || object.element_id === deletedElementId) {
      canvas.remove(object);
      return;
    }

    const objectIndex = getAdditionalBackgroundIndex(object);

    if (objectIndex === null || objectIndex <= index) {
      return;
    }

    object.element_id = `additional-${objectIndex - 1}`;
    object.id = `add_bk_theme_img_${objectIndex - 1}`;
  });

  window.displayBuilderHelper?.setDisplayLayerMetadata?.(
    currentData[DISPLAY_BUILDER_LAYER_META_KEY] || []
  );
  window.dispatchEvent(new CustomEvent('display-builder:background-layers-changed'));

  return true;
}
